import get from 'lodash.get'
import qs from 'qs'
import trackPageGTM from './trackPageGTM'
import trackEventGTM from './trackEventGTM'

export const getPageName = (pageKey) => {
  return pageKey.match(/[a-z]+-(.+)/)[1].replace(/-/g, ' ')
}
export class Analytics {
  constructor({ brand }) {
    this.brand = brand
  }

  trackEvent(data) {
    const eventData = { ...data }

    if (get(eventData, 'eventInfo')) {
      eventData.event = data.eventInfo.eventName
      eventData.effect = data.eventInfo.effect
      delete eventData.eventInfo
    }

    trackEventGTM(eventData)
  }

  trackPage(headAnalyticsData, locale, deviceType, listing) {
    trackPageGTM(headAnalyticsData, locale, this.brand, deviceType, listing)
  }

  trackCampaignCta(link, option = {}) {
    const {
      overrider = (obj) => obj,
      seperator = '-_-',
      param = 'cm_sp',
      customTrack = null
    } = option

    const queryString = link.substring(link.indexOf('?') + 1)
    const queryParams = qs.parse(queryString)
    const cmspQueryParam = queryParams[param] || ''
    if (!cmspQueryParam) return

    const params = cmspQueryParam.split(seperator) || []
    const [placement, position, campaignName, campaignStartDate] = params

    const baseEvent = {
      event: 'site merchandising - click',
      effect: 'campaign click',
      category: {
        primaryCategory: 'site merchandising',
        subCategory: 'campaign'
      },
      attributes: {
        placement,
        position,
        campaignName,
        campaignStartDate
      }
    }

    const finalEvent = overrider ? overrider(baseEvent) : baseEvent

    if (customTrack && typeof customTrack === 'function') {
      customTrack(finalEvent)
    } else {
      this.trackEvent(finalEvent)
    }
  }
}
